import React from 'react';

interface MeetingPrepModalProps {
  onClose: () => void;
}

const MeetingPrepModal: React.FC<MeetingPrepModalProps> = ({ onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Generate Meeting Prep Notes</h3>
        <div style={{ marginBottom: '20px' }}>
          <h4>Coming Soon:</h4>
          <p>Here will be a nice summary of the topic notes you can use to prepare for a customer meeting.</p>

          <p>Summary will be generated from a mix of the topic session transcription, and the latest info about the relevant AWS product, service, or feature discussed.</p>
          
          <p><strong>Summary sections will include:</strong></p>
          <ul>
            <li>customer discovery and opportunity qualification questions</li>
            <li>pricing</li>
            <li>pros/cons</li>
            <li>gotchas/consideration points</li>
            <li>competing products</li>
          </ul>
          
          <p>Please inform <strong>ryanmasc@</strong> with any other ideas you have for this feature!</p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <button onClick={onClose} className="btn btn-secondary">Close</button>
        </div>
      </div>
    </div>
  );
};

export default MeetingPrepModal;
